var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 23.375L4.25 27.54V15.5833H8.5V23.375ZM15.5833 20.7683L13.3592 18.87L11.3333 20.74V9.91667H15.5833V20.7683ZM22.6667 18.4167L18.4167 22.6667V4.25H22.6667V18.4167ZM26.6475 18.1475L24.0833 15.5833H31.1667V22.6667L28.6308 20.1308L18.4167 30.26L13.5008 25.9817L8.14583 31.1667H4.25L13.4158 22.185L18.4167 26.4067",
    fill: "#F58220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteady);
export default __webpack_public_path__ + "static/media/steady.5dd09a7c671e4ee3ef5fec1788bbafb2.svg";
export { ForwardRef as ReactComponent };